import React, { useEffect } from 'react';
import { Row, Col, Form, FormGroup, Input, Label } from 'reactstrap';
import PropTypes from 'prop-types';
import { BODYSITE_BUTTON_GROUPS } from './ConstBodySiteBtns';
import Body from '../Components/layout/Body';
import { BodySiteBtnsView } from './BodySiteBtnsView';

const PHYSICAL_BASIC_HELP = `
  <div>
    <p><strong>Purpose:</strong> This is an initial screen for physical access sites.  
    Just select body sites that seem promising and potentially effective for this client. 
    You'll do a more in-depth assessment of these body sites in the next step.
    </p>
    <p><strong>Note:</strong> Don't feel like you have to select every single body site that the client can control.  Just focus on the ones that make the most sense as potential access sites.  
    For example, if the client has some finger / hand function, their knee function may not be that relevant for access. You can always add more sites later if you need to keep searching.
    </p>
    <p>If it is challenging to identify potential body sites, consider the following options:
      <ul>
        <li>Eye movements (up/down, left/right)</li>
        <li>Eye blinks</li>
        <li>Furrow brow</li>
        <li>Purse lips</li>
        <li>Raise cheek (left or right side)</li>
        <li>Smile</li>
        <li>Open mouth / jaw</li>
        <li>Clench teeth</li>
        <li>Head movement (up/down, left/right, turn, tilt)</li>
        <li>Shoulder shrug</li>
        <li>Biceps movement / triceps movement</li>
        <li>Forearm muscle movement</li>
        <li>Wrist flexion / extension</li>
        <li>Thumb (up/down, press down, lateral, curl)</li>
        <li>Fingers (up/down, press down, lateral, curl)</li>
        <li>Foot (lift, flex, extend, tilt)</li>
        <li>Toes (wiggle, curl, press)</li>
      </ul>
      Some of these may be particularly applicable to the low/no-tech case. Videos with more info about these are available on the next page on in-depth assessment of physical abilities.
    </p>
    <div>
`

const propTypes = {
  firstName: PropTypes.string,
  bodySites: PropTypes.arrayOf(PropTypes.string),
  onChangeBodySites: PropTypes.func.isRequired,
  saveFormData: PropTypes.func.isRequired,
  onContinue: PropTypes.func.isRequired
};

const defaultProps = {
  firstName: 'the client',
  bodySites: []
};

//content sub-component with unique content for this page
function PhysicalBasicContent(props) {
  const firstName = props.firstName;
  const bodySites = props.bodySites ?? [];
  const onChangeBodySites= props.onChangeBodySites;

  console.log("rendering PhysicalBasicContent form with bodySites: " + bodySites);
  return(
    <>
      <p>Check the body sites you want to investigate further, those that appear to have some voluntary, controlled movement.</p>
      <Form>
        <BodySiteBtnsView
          bodySites={bodySites}
          onChangeBodySites={onChangeBodySites}
        />
      </Form>
    </>
  );
}

//main component for this page
//basic pattern is to set up the pageData, define the unique content for the page (above),
//then render the page using <Body> component
function EvaluateAbilitiesPhysicalBasic(props) {
  const firstName = props.firstName;
  const bodySites = props.bodySites;
  const onChangeBodySites = props.onChangeBodySites;
  const saveFormData = props.saveFormData;
  const onContinue = props.onContinue;

  console.log("rendering EvaluateAbilitiesPhysicalBasic");

  const pageData = {
    image: "./assets/images/target-icon.jpg",
    faIcon: "fa-child",
    pageSymbolClassName: "aa-section-symbol eval",

    title: `At a basic level, what are some possible physical access sites that ${firstName} might be able to use?`,
    subTitle: "",
    learnMore: {linkText: "Learn More about defining physical access sites",
                title: "Defining physical access sites",
                content: PHYSICAL_BASIC_HELP
                },
    nextRoute: "", //not used since we use onContinue
    sidebar: true
  }

  useEffect(() => {
    console.log('EAPBasic mounted');
    return () => {
      console.log('EAPBasic unmounting and saving...');
      saveFormData();
    }
  }, [saveFormData])

  return(
    <>
    <Body page={pageData} 
      contentComponent={<PhysicalBasicContent firstName={firstName} bodySites={bodySites} onChangeBodySites={onChangeBodySites}/>}
      onContinue={onContinue} 
    />
    </>
  );
}

EvaluateAbilitiesPhysicalBasic.propTypes = propTypes;
EvaluateAbilitiesPhysicalBasic.defaultProps = defaultProps;

export default EvaluateAbilitiesPhysicalBasic;